import { ProjectDataDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
  })
  export class GetAnfrageProjectDataResolver  {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProjectDataDisplayModel | undefined> {
      let id: string = <string>route.params['id'];

      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.id && this.portalContextService.CurrentAnfrage.projectData)
        return of(this.portalContextService.CurrentAnfrage.projectData).toPromise();
        
      return this.anfrageService.apiAnfrageAnfrageIdProjectDataGet({ anfrageId: id }).pipe(map(response => {
        if(response){
          if(!this.portalContextService.CurrentAnfrage?.projectData)
            this.portalContextService.CurrentAnfrage.projectData = response;

          if(this.portalContextService.CurrentAnfrage?.projectData)
            return this.portalContextService.CurrentAnfrage.projectData;
        }

        return undefined;
      })).toPromise();
    }
  }